(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/matchname/assets/javascripts/handlebars-helpers.js') >= 0) return;  svs.modules.push('/components/sport/matchname/assets/javascripts/handlebars-helpers.js'); 
'use strict';

(function(svs) {
  var logger;
  if (typeof exports === 'object') {
    var trinidad = require('trinidad-core').core;

    registerHelpers(
      require('hbs'),
      trinidad.components.require('sport', 'oddset-utils').utils
    );

    svs.oddset = svs.oddset || {};
    svs.oddset.utils = trinidad.components.require(
      'sport',
      'oddset-utils'
    ).utils;
    logger = trinidad.logger('ui:matchname');
  } else {
    registerHelpers(Handlebars);
    logger = new svs.core.log.Logger('ui:matchname');
  }

  var MATCH_ENDED_STATUSES = [
    25,
    28,
    29,
    30,
    31,
    32,
    33,
    41,
    116,
    117,
    118,
    119,
    120,
    121
  ];

  var getWinningTeam = function(matchObj) {
    var match = matchObj.match || matchObj,
      status = match.statusId || match.status,
      winner = '',
      intHomeResult = 0,
      intAwayResult = 0,
      matchEnded = MATCH_ENDED_STATUSES.indexOf(status) > -1;

    if (matchEnded) {
      var gameCurrentResult = match.result.filter(function(obj) {
        return obj.type === svs.oddset.GAME_CURRENT;
      });

      if (
        gameCurrentResult &&
        gameCurrentResult.length > 0 &&
        gameCurrentResult[0].rawResult
      ) {
        var versionSportAndSetStanding = gameCurrentResult[0].rawResult.split(
          ':'
        );
        var setStanding = versionSportAndSetStanding[2]
          .split(',')[0]
          .split('-');
        if (setStanding[0] > setStanding[1]) {
          winner = 'home';
        } else if (setStanding[0] < setStanding[1]) {
          winner = 'away';
        }
      } else {
        if (match.homeTeam) {
          intHomeResult = parseInt(match.homeTeam.result, 10);
          intAwayResult = parseInt(match.awayTeam.result, 10);
        } else {
          intHomeResult = parseInt(match.participants[0].result, 10);
          intAwayResult = parseInt(match.participants[1].result, 10);
        }
      }

      if (intHomeResult > intAwayResult) {
        winner = 'home';
      } else if (intAwayResult > intHomeResult) {
        winner = 'away';
      }
    }

    return winner;
  };

  var isDrawLive = function(match, regCloseTime) {
    return (
      Date.parse(regCloseTime) &&
      new Date(regCloseTime).getTime() < Date.now() &&
      (!match || match.statusId > 0)
    );
  };

  function registerHelpers(hbs) {
    hbs.registerHelper('fixData', function(data, options) {
      if (data) {
        var match;

        if (data.match) {
          match = data.match;
        } else if (data.matchId) {
          match = data;
        } else if (data.league && data.sport && data.description) {
        } else {
          return '';
        }

        data.matchNameObj = {
          match: match,
          league: data.league || match.league,
          sport: data.sport || match.sport || match.league.sport,
          participants: data.participants || null,
          isSportWithSets: data.isSportWithSets || null,
          hasParticipants: true,
          isStarted: match && match.statusId > 0,
          type: options.hash.type,
          description: data.description || data.drawDescription
        };

        data.matchNameObj.enabledDeepLink = data.enabledDeepLink;

        if (!data.matchNameObj.participants && match && match.participants) {
          data.matchNameObj.participants = data.match.participants;
        }

        if (data.matchNameObj.sport) {
          if (typeof data.matchNameObj.sport === 'number') {
            data.matchNameObj.isSportWithSets =
              data.matchNameObj.sport === svs.statistics.constants.TENNIS ||
              data.matchNameObj.sport ===
                svs.statistics.constants.TABLE_TENNIS ||
              data.matchNameObj.sport === svs.statistics.constants.BADMINTON ||
              data.matchNameObj.sport.id ===
                svs.statistics.constants.BEACH_VOLLEYBALL ||
              data.matchNameObj.sport.id ===
                svs.statistics.constants.VOLLEYBALL;
          } else {
            data.matchNameObj.isSportWithSets =
              data.matchNameObj.sport.id === svs.statistics.constants.TENNIS ||
              data.matchNameObj.sport.id ===
                svs.statistics.constants.TABLE_TENNIS ||
              data.matchNameObj.sport.id ===
                svs.statistics.constants.BADMINTON ||
              data.matchNameObj.sport.id ===
                svs.statistics.constants.BEACH_VOLLEYBALL ||
              data.matchNameObj.sport.id ===
                svs.statistics.constants.VOLLEYBALL;
          }
        }

        if (!data.matchNameObj.participants) {
          if (match && match.homeTeam) {
            data.matchNameObj.participants = [
              {
                id: match.homeTeam.id,
                mediumName: match.homeTeam.mediumName,
                name: match.homeTeam.name,
                type: 'home'
              },
              {
                id: match.awayTeam.id,
                mediumName: match.awayTeam.mediumName,
                name: match.awayTeam.name,
                type: 'away'
              }
            ];
          } else {
            data.matchNameObj.hasParticipants = false;
          }
        }
      }

      return '';
    });

    hbs.registerHelper('formatMatchName', function(name) {
      if (name) {
        name = name.split(' ').join('&nbsp;');
      }
      return name;
    });

    hbs.registerHelper('showRedCards', function(noOfRedCards, isOddsetWidget) {
      var accum = '';
      for (var i = 0; i < noOfRedCards; ++i) {
        if (!isOddsetWidget) {
          accum += '<i class="red-card icon-default icon-card match-card"></i>';
        } else {
          accum += '<i class="icon-default icon-card matchname-red-card"></i>';
        }
      }
      return accum;
    });

    hbs.registerHelper('showIfLive', function(draw) {
      var description = '',
        isLive = isDrawLive(draw.match, draw.regCloseTime);

      if (
        (draw.hasLiveDraw || draw.categoryId === 2)  &&
        !isLive
      ) {
        description +=
          '<span class="matchname-live-text-not-started f-condensed">LIVESPEL</span>';
      } else if (isLive) {
        description +=
          '<span class="matchname-live-text f-condensed">LIVESPEL</span>';
      }

      return description;
    });

    hbs.registerHelper('formatScore', function(matchObj, isHome) {
      var match = matchObj.match || matchObj,
        result = '',
        homeResult = '',
        awayResult = '';

      if (
        match &&
        svs.oddset.utils.isMatchStarted(match) &&
        match.result &&
        match.result.length > 0
      ) {
        result = svs.oddset.utils.result(match);
      }

      if (result) {
        homeResult = result.home ? result.home : '';
        awayResult = result.away ? result.away : '';
      }

      return isHome ? homeResult : awayResult;
    });

    hbs.registerHelper('formatBigScore', function(matchObj) {
      var match = matchObj.match || matchObj,
        returnStr = '-',
        result;

      if (
        match &&
        svs.oddset.utils.isMatchStarted(match) &&
        match.result &&
        match.result.length > 0
      ) {
        result = svs.utils.result.getResult(match);

        if (result && result.home) {
          returnStr = result.home + '&nbsp;-&nbsp;' + result.away;
        }
      }
      return returnStr;
    });

    hbs.registerHelper('hasResult', function(match, options) {
      match = match.match || match;
      var result;

      if (match && match.result && match.result.length > 0) {
        result = svs.utils.result.getResult(match);

        if (result && result.home) {
          return options.fn(this);
        }
      }

      return options.inverse(this);
    });

    hbs.registerHelper('formatScoreHomeAway', function(matchObj, type) {
      var result = '-';
      if (hbs.helpers && hbs.helpers.formatScore) {
        result = hbs.helpers.formatScore(matchObj, type === 'home');
        result = result !== '' ? result : '-';
      }
      return result;
    });

    hbs.registerHelper('getWinLoseClass', function(match, isHome) {
      match = match.match || match;

      var winLoseClass = '',
        winner = getWinningTeam(match);

      if (isHome) {
        if (winner === 'away') {
          winLoseClass = 'matchname-loser';
        }
      } else {
        if (winner === 'home') {
          winLoseClass = 'matchname-loser';
        }
      }

      return winLoseClass;
    });

    hbs.registerHelper('gameResult', function(match, isHome, isBig) {
      var result,
        matchStatusId,
        currentSet,
        returnObj = { home: '', away: '' },
        finishedMatch,
        currentServer,
        curr,
        ballClass = isBig ? 'tennis-ball-dot-large' : 'tennis-ball-dot',
        tennisGameClass = isBig ? 'tennis-game tennis-game-big' : 'tennis-game',
        i;

      if (match.result) {
        result = match.result;
        matchStatusId = match.statusId || match.status;
      } else if (match.match.result) {
        result = match.match.result;
        matchStatusId = match.match.statusId || match.match.status;
      } else {
        return '';
      }

      finishedMatch = MATCH_ENDED_STATUSES.indexOf(matchStatusId) > -1;

      var gameCurrentResult = result.filter(function(obj) {
        return obj.type === svs.oddset.GAME_CURRENT;
      });

      if (
        gameCurrentResult &&
        gameCurrentResult.length > 0 &&
        gameCurrentResult[0].rawResult
      ) {
        try {
          var rawResultParts = gameCurrentResult[0].rawResult.split(',');
          var versionSportAndSetStanding = rawResultParts[0].split(':');
          var setStanding = versionSportAndSetStanding[2];
          var version = versionSportAndSetStanding[0];

          var finishedSetRegExp = /\(([^)]+)\)/;

          var finishedSets = rawResultParts[1].match(finishedSetRegExp);
          var finishedSetsArr =
            finishedSets && finishedSets[1] ? finishedSets[1].split('|') : [];
          var currentSetStanding;
          var currentGameStanding;
          var currentServerString;

          if (!finishedMatch) {
            var currentResultPartIndex;
            if (finishedSetsArr.length) {
              currentResultPartIndex = 2;
            } else {
              currentResultPartIndex = 1;
            }

            currentSetStanding = rawResultParts[currentResultPartIndex];

            if (currentResultPartIndex < rawResultParts.length - 2) {
              currentGameStanding = rawResultParts[++currentResultPartIndex];
            }

            if (currentResultPartIndex < rawResultParts.length - 1) {
              currentServerString = rawResultParts[currentResultPartIndex + 1];
              currentServer = currentServerString.split('-');

              if (currentServer[0]) {
                returnObj.home =
                  '<span class="tennis-cell"><span class="' +
                  ballClass +
                  '"></span></span>';
                returnObj.away = '<span class="tennis-cell"></span>';
              } else if (currentServer[1]) {
                returnObj.home = '<span class="tennis-cell"></span>';
                returnObj.away =
                  '<span class="tennis-cell"><span class="' +
                  ballClass +
                  '"></span></span>';
              }
            }
          }

          if (finishedSetsArr && finishedSetsArr.length > 0) {
            for (i = 0; i < finishedSetsArr.length; i++) {
              curr = finishedSetsArr[i].split('-');
              returnObj.home +=
                '<span class="tennis-result-faded tennis-cell">' +
                curr[0] +
                '</span>';
              returnObj.away +=
                '<span class="tennis-result-faded tennis-cell">' +
                curr[1] +
                '</span>';
            }
          }

          if (finishedMatch) {
            var setStandingArr = setStanding.split('-');
            returnObj.home =
              '<span class="table-cell tennis-cell finished-tennis-sets">' +
              setStandingArr[0] +
              '</span><span class="tennis-cell">|</span>' +
              returnObj.home;
            returnObj.away =
              '<span class="table-cell tennis-cell finished-tennis-sets">' +
              setStandingArr[1] +
              '</span><span class="tennis-cell">|</span>' +
              returnObj.away;
          } else {
            if (currentSetStanding) {
              currentSet = currentSetStanding.split('-');
              returnObj.home +=
                '<span class="tennis-cell">' + currentSet[0] + '</span>';
              returnObj.away +=
                '<span class="tennis-cell">' + currentSet[1] + '</span>';
            }

            if (currentGameStanding) {
              var currentGameArray = currentGameStanding.split('-');

              if (version === '1') {
                if (currentServer[0].indexOf('A') !== -1) {
                  currentGameArray[0] = 'A';
                } else if (currentServer[1].indexOf('A') !== -1) {
                  currentGameArray[1] = 'A';
                }
              }

              returnObj.home +=
                '<span class="tennis-cell">|</span><span class="' +
                tennisGameClass +
                ' tennis-cell">' +
                currentGameArray[0] +
                '</span>';
              returnObj.away +=
                '<span class="tennis-cell">|</span><span class="' +
                tennisGameClass +
                ' tennis-cell">' +
                currentGameArray[1] +
                '</span>';
            }
          }
        } catch (e) {
          logger.error(
            'Err parse Game Current: ' +
              gameCurrentResult[0].rawResult +
              ' matchId: ' +
              (match.matchId || match.match.matchId)
          );
        }
      } else {

        if (isBig) {
          returnObj.home += '<span class="tennis-cell">-</span>';
          returnObj.away += '<span class="tennis-cell">-</span>';
        }
      }

      return isHome ? returnObj.home : returnObj.away;
    });

    hbs.registerHelper('isMatchStarted', function(match, options) {
      if (svs.oddset.utils.isMatchStarted(match)) {
        return options.fn(this);
      }
      return options.inverse(this);
    });
  }
})(svs || global.svs || {});

 })(window);